export const DELETE_SESSION_MEDIA_FILE = "SESSION_DELETE_MEDIA_FILE";
export const DELETE_SESSION_MEDIA_FILE_SUCCESS = "SESSION_DELETE_MEDIA_FILE_SUCCESS";
export const DELETE_SESSION_MEDIA_FILE_ERROR = "SESSION_DELETE_MEDIA_FILE_ERROR";
export const RESET_DELETE_SESSION_MEDIA_FILE = "SESSION_RESET_DELETE_MEDIA_FILE";

export interface DeleteMediaFile {
  type: typeof DELETE_SESSION_MEDIA_FILE;
  payload: { idFile: number };
}

export interface DeleteMediaFileSuccess {
  type: typeof DELETE_SESSION_MEDIA_FILE_SUCCESS;
  payload: null;
}

export interface DeleteMediaFileError {
  type: typeof DELETE_SESSION_MEDIA_FILE_ERROR;
  payload: string | boolean;
}

export interface ResetDeleteMediaFile {
  type: typeof RESET_DELETE_SESSION_MEDIA_FILE;
  payload: null;
}

export interface State {
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | DeleteMediaFile
  | DeleteMediaFileSuccess
  | DeleteMediaFileError
  | ResetDeleteMediaFile;

